/* @flow strict */

import * as React from 'react';

type PropsType = {
  view: string,
  changeView: (string) => void
};

const HeaderHelper = (props: PropsType): React.Element<typeof React.Fragment> => {
  return (
    <>
      <span className="text">
        {props.view === '/login' ?
          'Are you new around here?' :
          null
        }

        {props.view === '/reset-password' ?
          'Do you know your password?' :
          null
        }

        {
          props.view === '/sign-up' ||
          props.view === '/resend-email' ||
          props.view === '/confirm-email' ?
          'Do you already have an account?' :
          null
        }
      </span>
      <a
        className="btn btn-default btn-sm btn-round"
        href="#"
        role="button"
        onClick={(e: SyntheticEvent<HTMLLinkElement>) => {
          e.preventDefault();
          let _view = '';

          switch (props.view) {
            case '/login':
              _view = '/sign-up';
              break;
            case '/reset-password':
            case '/sign-up':
            case '/resend-email':
            case '/confirm-email':
              _view = '/login';
              break;
            default:
              _view = '';
          }

          props.changeView(_view);
        }}
      >
      {props.view === '/login' ?
        'Create an account' :
        null
      }

      {(
        props.view === '/reset-password' ||
        props.view === '/sign-up' ||
        props.view === '/resend-email' ||
        props.view === '/confirm-email'
      ) ?
        'Login' :
        null
      }
      </a>
    </>
  );
};

export default HeaderHelper;
